import { Customer } from '@api/Trinium/Endpoints/Customer/types';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import classNames from 'classnames/bind';

import styles from './MobileListItem.module.css';
const stylesContext = classNames.bind(styles);

export default function CustomerMobileListItem({ row }: GridRenderCellParams<Customer>) {
	const nameStyles = stylesContext({
		name: true,
		['credit-warning']: row.hasCreditWrn
	});

	const amountStyles = stylesContext({
		credit: true,
		negative: row.availCredit && row.availCredit < 0
	});

	return (
		<div className={styles['list-item']}>
			<span className={nameStyles}>{row.name}</span>
			<span className={styles['code']}>{row.id}</span>
			<span className={amountStyles}>{`$ ${
				row.availCredit?.toLocaleString(undefined, {
					minimumFractionDigits: 2
				}) ?? '0.00'
			}`}</span>
			<span className={styles['address']}>{row.addr1}</span>
			<span className={styles['city']}>{row.city}</span>
		</div>
	);
}
